import { createFileRoute, notFound } from '@tanstack/react-router'
import { LegalPage } from '../../components/LegalPage'
import { legalDoc } from '../../content/legal'
import { getDict, parseLocale } from '../../i18n'
import { seoHead } from '../../lib/seo'
import { SITE_ORIGIN } from '../../lib/site'

export const Route = createFileRoute('/{-$locale}/privacy')({
  beforeLoad: ({ params }) => {
    if (!parseLocale(params.locale)) throw notFound()
  },
  head: ({ params }) => {
    const locale = parseLocale(params.locale) ?? 'ja'
    const { doc } = legalDoc('privacy', locale)
    return seoHead({
      origin: SITE_ORIGIN,
      locale,
      path: '/privacy',
      title: getDict(locale).meta.privacyTitle,
      description: doc.intro,
    })
  },
  component: () => <LegalPage kind="privacy" />,
})
